import { getConditionalObject } from 'utils/data';

export const dividerStyles = {
  margin: '12px 0 18px',
};

export const getListTableContainerStyles = ({ customStyles, isFullWidthDivider }) => ({
  borderRadius: ({ shape }) => shape.radius.s,
  ...getConditionalObject(isFullWidthDivider, {
    paddingTop: '24px',
    '& .title': {
      paddingInline: '24px',
    },
  }),

  ...customStyles,
});

export const titleContainerCustomStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
